// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__N--tr","items":"Toggle_items__1vX6b","basket":"Toggle_basket__qUVHB","active":"Toggle_active__3vV0_"};